import { CommonResponse } from 'models/common';
import axiosClient from 'utils/axiosClient';
import { VideoFunction } from './models/videoFunction';

const videoFunctionService = {
  getItem(id: number): Promise<CommonResponse<VideoFunction>> {
    const url = `/video-function/${id}`;
    return axiosClient.get(url);
  },
};

export default videoFunctionService;
